import { ACCOUNT_SUBTYPE_LABELS } from "../constants"
import { ACCOUNT_TYPE_TO_SUBTYPE } from "../constants/formOptions"

import type { GlAccountType } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const getSubtypeOptionsForType = (accountType: GlAccountType | null | undefined): Option<string>[] => {
  if (!accountType) return []

  const allowedSubtypes = ACCOUNT_TYPE_TO_SUBTYPE[accountType]
  return allowedSubtypes
    .map((subType) => ({
      value: subType,
      label: ACCOUNT_SUBTYPE_LABELS[subType],
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}
